.panel {
  border: 1px solid var(--c-border);
  border-radius: var(--radius-md);
  background: var(--c-surface);
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.sunken {
  background: var(--c-surface-sunken);
}

.glow {
  border-color: color-mix(in srgb, var(--c-brand) 55%, var(--c-border));
  box-shadow: 0 0 0 1px var(--glow), 0 0 18px -4px var(--glow);
}

.accented {
  border-color: var(--c-brand);
}

.clip {
  overflow: hidden;
}

.header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 10px;
  min-height: 48px;
  padding: 10px var(--panel-pad-x);
  border-bottom: 1px solid var(--c-border);
}

.headerFlush {
  border-bottom: 0;
}

.titleBlock {
  display: flex;
  align-items: baseline;
  gap: 10px;
  min-width: 0;
}

/* Ellipsis is the last resort: the header wraps its actions onto a second row first, so the title
   only truncates when it alone is wider than the panel — never runs under the ⓘ beside it. */
.title {
  font-size: var(--text-callout);
  font-weight: 600;
  white-space: nowrap;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.subtitle {
  font-size: 12px;
  color: var(--c-text-tertiary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  flex: none;
}

.body {
  padding: 12px var(--panel-pad-x) 16px;
  min-width: 0;
}

.bodyFlush {
  padding: 0;
}

.footer {
  padding: 10px var(--panel-pad-x);
  border-top: 1px solid var(--c-border);
  font-size: 12px;
  color: var(--c-text-tertiary);
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
